<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md class="subnav__reduced-padding">
    <sbnb-back-button style="margin-bottom: 20px"></sbnb-back-button>

    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'ops-team-detail'"></sbnb-helptext-wrapper>

    <sbnb-cs-debug-item *ngIf="member && member.id" label="teammate_id" [value]="member.id"></sbnb-cs-debug-item>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs></sbnb-page-header>
    </app-feature-flag-tabs>

    <ng-container *ngIf="member || newMode; else loading">
      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
        <div fxFlex fxLayoutAlign="start center" fxLayoutGap="16px">
          <sbnb-team-icon *ngIf="!newMode" [size]="32" [member]="member"></sbnb-team-icon>
          <h2 class="nomargin">
            <span *ngIf="member" class="ellipsis">{{ member.name }}</span>
            <span *ngIf="newMode" class="ellipsis">New teammate...</span>
          </h2>
        </div>
        <div *ngIf="!newMode" fxLayout fxLayoutAlign="start center" fxLayoutGap="16px">
          <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
          <button
            mat-flat-button
            class="button__small"
            ngxClipboard
            [cbContent]="member.ical_suffix"
            (click)="copiedToClipboard()">
            Copy the iCal feed
          </button>

          <sbnb-more-menu-trigger [matMenuTriggerFor]="icalMenu"></sbnb-more-menu-trigger>
          <mat-menu #icalMenu="matMenu">
            <button mat-menu-item (click)="sendInstructions()">Send instructions</button>
            <button mat-menu-item (click)="resetCalendar()">
              <span>
                <span>Reset access</span>
              </span>
            </button>
          </mat-menu>
        </div>
      </div>

      <div *ngIf="member.bounced" class="email-warning" fxLayout fxLayoutAlign="start center" fxLayoutGap="6px">
        <img src="assets/iconography/warning.svg" alt="Warning icon" />
        <span>
          Emails sent to this teammate have bounced. If you have confirmed this is a valid email, please contact
          support.
        </span>
      </div>

      <div class="team__section-container" fxLayout="column" fxLayoutGap="8px">
        <div class="team__header">
          <h3 fxLayout fxLayoutAlign="start center" fxLayoutGap="16px">
            <img src="/assets/iconography/team.svg" width="20" height="20" />
            <span>Details</span>
          </h3>
        </div>

        <form [formGroup]="memberForm">
          <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="12px">
            <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Company</strong>
            <div fxFlex="300px" fxFlex.lt-md="none">
              <mat-form-field class="input__mini fw">
                <input matInput formControlName="companyName" />
              </mat-form-field>
            </div>
          </div>

          <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="12px">
            <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">First name</strong>
            <div fxFlex="300px" fxFlex.lt-md="none">
              <mat-form-field class="input__mini fw">
                <input matInput formControlName="firstName" />
                <mat-error *ngIf="memberForm.get('firstName').hasError('required')">First name is required</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="12px">
            <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Last name</strong>
            <div fxFlex="300px" fxFlex.lt-md="none">
              <mat-form-field class="input__mini fw">
                <input matInput formControlName="lastName" />
                <mat-error *ngIf="memberForm.get('lastName').hasError('required')">Last name is required</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="12px">
            <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Email</strong>
            <div fxFlex="300px" fxFlex.lt-md="none">
              <mat-form-field class="input__mini fw">
                <input matInput formControlName="email" />
                <mat-error *ngIf="memberForm.get('email').hasError('required')">Email is required</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="12px">
            <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Phone</strong>
            <div fxFlex="300px" fxFlex.lt-md="none">
              <mat-form-field class="input__mini fw">
                <ngx-mat-intl-tel-input
                  [preferredCountries]="['us']"
                  [enableAutoCountrySelect]="true"
                  [enablePlaceholder]="true"
                  [enableSearch]="true"
                  name="phone"
                  formControlName="phone"
                  #phone></ngx-mat-intl-tel-input>
                <mat-hint>e.g. {{ phone.selectedCountry.placeHolder }}</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="12px">
            <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Address</strong>
            <div fxFlex="300px" fxFlex.lt-md="none">
              <mat-form-field class="input__mini fw">
                <input id="pac-input" matInput [(ngModel)]="addressLabel" [ngModelOptions]="{ standalone: true }" />
              </mat-form-field>
            </div>
          </div>

          <ng-container *ngIf="languages$ | async as languages">
            <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="12px">
              <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Language</strong>
              <div fxFlex="300px" fxFlex.lt-md="none">
                <mat-form-field class="input__mini fw">
                  <mat-select formControlName="language">
                    <mat-option *ngFor="let lang of languages" [value]="lang.code">
                      {{ lang.native }} ({{ lang.english }})
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="currencies$ | async as currencies">
            <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="12px">
              <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Currency</strong>
              <div fxFlex="300px" fxFlex.lt-md="none">
                <mat-form-field class="input__mini fw">
                  <mat-select formControlName="currency">
                    <mat-option *ngFor="let curr of currencies" [value]="curr.key">
                      {{ curr.key }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </ng-container>
        </form>

        <div class="roles__container" *ngIf="possibleRoles && possibleRoles.length > 0">
          <div fxLayout fxLayoutAlign="space-between center" fxLayoutGap="4px" class="rule__scope-header">
            <mat-checkbox [checked]="member.all_services" (change)="allRolesChange($event)">
              <h4 fxFlex>Roles</h4>
            </mat-checkbox>
            <span *ngIf="!member.all_services">{{ member.services?.length }} selected</span>
            <span *ngIf="member.all_services">All roles</span>
          </div>
          <div
            [style.opacity]="member.all_services ? 0.2 : 1"
            [style.pointer-events]="member.all_services ? 'none' : null">
            <mat-checkbox
              *ngFor="let role of possibleRoles"
              class="fw"
              [checked]="member.all_services || member.services.indexOf(role.id) > -1"
              (change)="roleChange(role, $event)">
              <span>{{ role.name }}</span>
            </mat-checkbox>
          </div>
        </div>
      </div>

      <div class="team__section-container">
        <div class="team__header" fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
          <h3 class="nomargin" fxLayout fxLayoutAlign="start center" fxLayoutGap="16px">
            <sbnb-icon icon="properties" [size]="20" class="shrink-0 text-smoke-darker"></sbnb-icon>
            <span>Preferred properties</span>
          </h3>
          <span class="text__small">Does this teammate work on specific properties?</span>
        </div>

        <div class="rule__scope-box">
          <div fxLayout fxLayoutAlign="space-between center" fxLayoutGap="4px" class="rule__scope-header">
            <mat-checkbox [checked]="member.all_properties" (change)="allPropertyChange($event)">
              <h4 fxFlex>Properties</h4>
            </mat-checkbox>
            <span *ngIf="!member.all_properties">{{ member.properties?.length }} selected</span>
            <span *ngIf="member.all_properties">All properties</span>
          </div>
          <div
            [style.opacity]="member.all_properties ? 0.2 : 1"
            [style.pointer-events]="member.all_properties ? 'none' : null">
            <div>
              <sbnb-search-bar
                placeholderText="Search..."
                (searchChanged)="searchCriteriaProperties = $event"></sbnb-search-bar>
            </div>
            <div class="rules__scrollable">
              <ng-container *ngFor="let property of possibleProperties">
                <div
                  *ngIf="property.name | matchPropertySearchCriteria: searchCriteriaProperties"
                  fxLayout
                  fxLayoutGap="4px"
                  fxLayoutAlign="start center">
                  <mat-checkbox
                    style="width: 100% !important"
                    [checked]="member.all_properties || member.properties.indexOf(property.id) > -1"
                    (change)="propertyCheckboxChange(property, $event)">
                    <span fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
                      <img [src]="property.picture" class="property__img" />
                      <span fxFlex>{{ property.name }}</span>
                    </span>
                  </mat-checkbox>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="team__section-container" fxLayout fxLayoutAlign="space-between center">
        <button
          *ngIf="!newMode"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="8px"
          [disabled]="deleting"
          class="button__text ocean"
          mat-flat-button
          (click)="deletePrompt()">
          <img src="/assets/iconography/delete.svg" />
          Delete
          <mat-spinner *ngIf="deleting" class="button__spinner" [diameter]="30"></mat-spinner>
        </button>

        <button
          *ngIf="newMode"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="8px"
          [disabled]="saving"
          class="button__primary"
          mat-flat-button
          (click)="createMember()">
          <sbnb-icon icon="check" class="text-white"></sbnb-icon>
          Create
          <mat-spinner *ngIf="saving" class="button__spinner" [diameter]="30"></mat-spinner>
        </button>

        <div fxLayout fxLayoutAlign="end center">
          <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
        </div>
      </div>
    </ng-container>

    <ng-template #loading>
      <mat-spinner [diameter]="30"></mat-spinner>
    </ng-template>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
